module.exports = __webpack_public_path__ + "img/1f921.294250b.svg";